export default "__VITE_ASSET__Cghesoua__"